/* ============================================================
   VITSENSE — gedeelde interacties & animaties (theme-port)
   ============================================================ */
(function () {
  "use strict";
  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Header stuck state (op Horizon's header-component) ---- */
  function initHeader() {
    var header = document.querySelector("header-component");
    if (!header) return;
    var onScroll = function () {
      header.setAttribute("data-vs-stuck", window.scrollY > 12 ? "1" : "0");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));
    if (!els.length) return;
    function reveal(el) { el.classList.add("in"); }
    if (prefersReduced) { els.forEach(reveal); return; }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: "0px 0px -10% 0px" });
      els.forEach(function (el) { io.observe(el); });
    }
    // Robust fallback: reveal anything that has entered the viewport.
    function check() {
      var vh = window.innerHeight;
      for (var i = els.length - 1; i >= 0; i--) {
        var el = els[i];
        if (el.classList.contains("in")) { els.splice(i, 1); continue; }
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) reveal(el);
      }
    }
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check, { passive: true });
    check();
  }

  /* ---- Parallax ---- */
  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    if (!els.length || prefersReduced) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.12;
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var center = r.top + r.height / 2;
        var off = (center - vh / 2) / vh;
        var y = -off * speed * 100;
        el.style.transform = "translate3d(0," + y.toFixed(2) + "px,0) scale(1.16)";
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  /* ---- Hero carousel ---- */
  function initCarousel() {
    var heroes = Array.prototype.slice.call(document.querySelectorAll("[data-vs-carousel]"));
    heroes.forEach(function (hero) {
      var track = hero.querySelector(".vs-hero-track");
      var slides = Array.prototype.slice.call(hero.querySelectorAll(".vs-hero-slide"));
      if (slides.length < 2) return;
      var dotsWrap = hero.querySelector(".vs-hero-dots");
      var i = 0, timer = null;
      var INTERVAL = parseInt(hero.getAttribute("data-vs-interval"), 10) || 5800;

      var dots = slides.map(function (_, idx) {
        var b = document.createElement("button");
        b.setAttribute("role", "tab");
        b.setAttribute("aria-label", "Slide " + (idx + 1));
        b.addEventListener("click", function () { go(idx, true); });
        dotsWrap.appendChild(b);
        return b;
      });

      function render() {
        track.style.transform = "translateX(" + (-i * 100) + "%)";
        dots.forEach(function (d, idx) { d.setAttribute("aria-selected", idx === i ? "true" : "false"); });
        slides.forEach(function (s, idx) { s.setAttribute("aria-hidden", idx === i ? "false" : "true"); });
      }
      function go(n, user) {
        i = (n + slides.length) % slides.length;
        render();
        if (user) restart();
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function restart() {
        if (timer) clearInterval(timer);
        if (!prefersReduced) timer = setInterval(next, INTERVAL);
      }

      var nextBtn = hero.querySelector("[data-hero-next]");
      var prevBtn = hero.querySelector("[data-hero-prev]");
      if (nextBtn) nextBtn.addEventListener("click", function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener("click", function () { prev(); restart(); });

      var sx = 0, dragging = false;
      hero.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; dragging = true; }, { passive: true });
      hero.addEventListener("touchend", function (e) {
        if (!dragging) return; dragging = false;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); restart(); }
      }, { passive: true });

      hero.addEventListener("mouseenter", function () { if (timer) clearInterval(timer); });
      hero.addEventListener("mouseleave", restart);

      render();
      restart();
    });
  }

  /* ---- Favourites (visuele toggle; wishlist-integratie later) ---- */
  function initFav() {
    document.addEventListener("click", function (e) {
      var fav = e.target.closest(".vs-card-fav");
      if (fav) { e.preventDefault(); fav.classList.toggle("on"); }
    });
  }

  /* ---- Energietest: quiz-triggers zonder link wijzen naar de testpagina ---- */
  function initQuizLinks() {
    var QUIZ_URL = "/pages/energietest";
    document.querySelectorAll("[data-quiz-start]").forEach(function (el) {
      var href = el.getAttribute("href");
      if (el.tagName === "A" && (!href || href === "#")) el.setAttribute("href", QUIZ_URL);
    });
  }

  function init() {
    initHeader(); initReveal(); initParallax(); initCarousel(); initFav(); initQuizLinks();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* Theme-editor: secties worden live herladen — opnieuw initialiseren */
  document.addEventListener("shopify:section:load", function () {
    initReveal(); initParallax(); initCarousel(); initQuizLinks();
  });
})();
